import { useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';
import { ProductListItem } from '../types/ProductTypes';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getProductsByProcedure = useCallback(
        async (procedureId: number) => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }
                const response = await getApiData({
                    endpoint: `${apiUrl}/QueryProductMetaData?procedureId=${procedureId}`,
                });
                return response;
            } catch (error) {
                console.error(`Failed to fetch products for procedure ID ${procedureId}:`, error);
                throw error;
            }
        },
        [getApiData, appSettings]
    );

    // Extract products from the items key in the ProductQueryResultDto response
    const products = state.result?.items as ProductListItem[] | null;

    return {
        products,
        loading: state.isLoading,
        error: state.error,
        getProductsByProcedure,
    };
};
